import GetInitialSubscriptionRequestRequestModelBase from '../_generated/modelBases/get-initial-subscription-request-request-model-base';

export default class GetInitialSubscriptionRequestRequestModel extends GetInitialSubscriptionRequestRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
